<div class="section-full bg-gray">
  <!-- <iframe src="https://www.google.com/maps/d/u/1/embed?mid=1ExTGmJCeqJeDM7NvXuNYWzPiDYI9dCKc&ehbc=2E312F" width="100%" height="480"></iframe> -->
  <div style="position: relative">
    <div
      style="
        position: relative;
        padding-bottom: 75%;
        height: 0;
        overflow: hidden;
      "
    >
      <!-- <iframe
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        "
        loading="lazy"
        allowfullscreen
        src="https://maps.google.com/maps?q=6solve+it+services&output=embed"
      ></iframe> -->
      <iframe
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        "
        loading="lazy"
        allowfullscreen
        src="https://www.google.com/maps/d/embed?mid=1rFar--HnKce7kATtiaUUv39IsrIntG8&ehbc=2E312F"
        width="640"
        height="480"
      ></iframe>
    </div>
    <a
      href="https://aitohumanizetextconverter.com/"
      rel="noopener"
      target="_blank"
      style="
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      "
      >aitohumanizetextconverter.com</a
    >
  </div>
</div>
